import * as tslib_1 from "tslib";
import { takeUntil } from 'rxjs/operators';
import { OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as fromCart from '../../../cart/reducers';
import * as fromCheckout from '../../reducers';
import * as fromAuth from '../../../auth/reducers';
import * as cart from '../../../cart/actions/cart';
import * as checkout from '../../actions/checkout';
import * as catalog from '../../../catalog/actions/catalog';
import { ContainerBase } from '../../../core/base/container-base';
import chaining from '../../../core/helpers/chaining';
import * as products from '../../../catalog/actions/product';
import { DetailsContainer } from '../../../catalog/containers/details-container/details-container';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PageRoutingService } from '../../../core/services/page-routing.service';
import * as fromBase from '../../../base/reducers';
var CheckoutContainer = /** @class */ (function (_super) {
    tslib_1.__extends(CheckoutContainer, _super);
    function CheckoutContainer(store, pageRoutingSvc, modalSvc) {
        var _this = _super.call(this) || this;
        _this.store = store;
        _this.pageRoutingSvc = pageRoutingSvc;
        _this.modalSvc = modalSvc;
        _this.pageRoutingSvc.breadcrumbsStatus = false;
        _this.pageRoutingSvc.simplifiedHeaderStatus = false; // SK 19-02-2019 changed to false
        _this.cartOrder$ = store
            .pipe(select(fromCart.getOrder), takeUntil(_this.destroyed$));
        _this.checkoutPageSettings$ = store
            .pipe(select(fromBase.getCheckoutPageSettings), takeUntil(_this.destroyed$));
        _this.quantityPicker$ = store
            .pipe(select(fromBase.getQuantityPicker), takeUntil(_this.destroyed$));
        _this.addresses$ = store
            .pipe(select(fromAuth.getAddresses), takeUntil(_this.destroyed$));
        _this.committing$ = store
            .pipe(select(fromCheckout.isCreating), takeUntil(_this.destroyed$));
        _this.commitError$ = store
            .pipe(select(fromCheckout.getError), takeUntil(_this.destroyed$));
        _this.orderLines$ = store
            .pipe(select(fromCart.getCurrentOrderLines), takeUntil(_this.destroyed$));
        _this.orderLines$
            .subscribe(function (orderLines) { return _this.orderLines = orderLines; });
        _this.customerMinOrderValue$ = store
            .pipe(select(fromAuth.getCustomerMinOrderValue), takeUntil(_this.destroyed$));
        _this.deliverydates$ = store
            .pipe(select(fromCheckout.getDeliveryDates), takeUntil(_this.destroyed$));
        _this.backordercounts$ = store
            .pipe(select(fromCheckout.getBackorderCounts), takeUntil(_this.destroyed$));
        _this.customerDiscounts$ = store
            .pipe(select(fromAuth.getCustomerDiscounts), takeUntil(_this.destroyed$));
        _this.extraCosts$ = store
            .pipe(select(fromCart.getOrderExtraCosts), takeUntil(_this.destroyed$));
        return _this;
    }
    CheckoutContainer.prototype.ngOnInit = function () {
        this.store.dispatch(new checkout.ClearError());
        this.store.dispatch(new checkout.GetDeliveryDates());
        this.store.dispatch(new checkout.GetBackorderCounts());
    };
    CheckoutContainer.prototype.ngOnDestroy = function () {
        this.store.dispatch(new checkout.ClearDeliveryDates());
        this.pageRoutingSvc.breadcrumbsStatus = true;
        this.pageRoutingSvc.simplifiedHeaderStatus = false;
    };
    CheckoutContainer.prototype.detailsChanged = function (order) {
        this.store.dispatch(new checkout.Set(order));
    };
    CheckoutContainer.prototype.checkoutOrder = function (order) {
        this.store.dispatch(new checkout.Submit(order));
    };
    CheckoutContainer.prototype.changeLine = function (event) {
        var orderLineId = chaining(this.orderLines.find(function (line) { return chaining(line, 'product._id') === chaining(event, 'product'); }), '_id');
        if (chaining(event, 'quantity') > 0) {
            this.store.dispatch(new cart.Add({
                product: event.product,
                quantity: event.quantity,
                includeExtraCosts: event.includeExtraCosts
            }));
        }
        else if (event.quantity <= 0 && orderLineId)
            this.store.dispatch(new cart.Remove({
                lineId: orderLineId,
                includeExtraCosts: event.includeExtraCosts
            }));
    };
    CheckoutContainer.prototype.deleteLine = function ($event) {
        this.store.dispatch(new cart.Remove({
            lineId: $event,
            includeExtraCosts: true
        }));
    };
    CheckoutContainer.prototype.openDetails = function (product) {
        this.store.dispatch(new catalog.Init());
        this.store.dispatch(new products.Select(product));
        this.modalSvc.open(DetailsContainer, { centered: true, size: 'lg' });
    };
    return CheckoutContainer;
}(ContainerBase));
export { CheckoutContainer };
